{
  "pairing": {
    "title": "Pair this tablet",
    "instruction": "Enter this pairing code on the employee's Tablets page",
    "code": "Pairing code",
    "waiting": "Waiting to be paired...",
    "networkError": "Could not reach the server",
    "retry": "Try again"
  },
  "idle": {
    "instruction": "Waiting for the employee"
  },
  "connection": {
    "reconnecting": "Reconnecting...",
    "stateFailed": "Could not refresh. Trying again..."
  },
  "task": {
    "requiredFieldsNote": "Required fields are marked with an asterisk",
    "signature": "Signature",
    "clearSignature": "Clear signature",
    "signatureRequired": "Signature is required",
    "fieldRequired": "{{field}} is required",
    "tooLong": "{{field}} is too long",
    "submit": "Done",
    "submitting": "Sending...",
    "continue": "Continue",
    "cancel": "Cancel",
    "optional": "Optional",
    "invalidValue": "The value is not valid",
    "chooseCountry": "Choose the country",
    "chooseOption": "Choose...",
    "noMatch": "No results",
    "saveFailed": "The data could not be saved. Nothing was sent, please try again.",
    "discardTitle": "Discard the entered data?",
    "discardDescription": "The data and the signature will be deleted and not sent to the employee.",
    "discard": "Discard",
    "keepEditing": "Continue filling in",
    "invalidPhotoFile": "The photo is not valid. Choose another photo"
  },
  "done": {
    "title": "Thank you",
    "instruction": "Please wait for the employee"
  },
  "camera": {
    "capture": "Capture photo",
    "retake": "Retake photo",
    "choosePhoto": "Choose a photo",
    "denied": "Could not access the camera. Choose a photo from the device instead",
    "unavailable": "Camera is not available on this device. Choose a photo from the device instead",
    "tooLarge": "The photo is larger than the allowed size"
  },
  "scanner": {
    "instruction": "Point the camera at the code",
    "starting": "Starting the camera...",
    "scanning": "Looking for the code...",
    "denied": "Could not access the camera",
    "unavailable": "Camera is not available on this device",
    "sending": "Sending..."
  },
  "link": {
    "invalid": "This request has ended and is no longer available.",
    "loadFailed": "Could not reach the server",
    "retry": "Try again"
  }
}
